import { Component } from '@angular/core';
import { RidDemoPage } from '../../../components/rid-demo-page/rid-demo-page';
import { RidEggCartons } from '../../../components/rid-egg-cartons/rid-egg-cartons';

@Component({
  selector: 'app-egg-cartons-page',
  imports: [RidDemoPage, RidEggCartons],
  templateUrl: './egg-cartons-page.html',
})
export class EggCartonsPage {}
